import { RoomApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const roomCustomerApi = {
  search: wrap(RoomApi, RoomApi.prototype.searchCustomer),
  create: wrap(RoomApi, RoomApi.prototype.addCustomer),
  show: wrap(RoomApi, RoomApi.prototype.showCustomer),
  update: wrap(RoomApi, RoomApi.prototype.updateCustomer),
};
